module.exports = __webpack_public_path__ + "img/fuelpump.8c0526f1.svg";